module.exports = __webpack_public_path__ + "img/Jump Casting133.90699ecd.jpg";